import React from 'react';

import { InputLabel } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import { StatusChangeChips } from './status-change-chips';

import { getOtherButtonStatuses, statusDisplay } from '../../config/application-status-config';

type InputProps = {
  emailOrUsername: string;
  subscribedStatuses: Array<ApplicationStatus> | null;
  usesPhoneInterview: boolean;
  onAdd: (event: React.ChangeEvent<{ name?: string | undefined; value: unknown }>) => void;
  onRemove: (removedStatus: ApplicationStatus) => () => void;
};

export const StatusChangeNotificationSelect = (props: InputProps) => {
  const { emailOrUsername, subscribedStatuses, usesPhoneInterview, onAdd, onRemove } = props;

  const selectedStatuses = subscribedStatuses || [];
  const applicantStatuses = getOtherButtonStatuses(usesPhoneInterview);
  const unselectedStatuses = applicantStatuses.filter(
    (status) => !selectedStatuses.includes(status),
  );

  return (
    <>
      <FormControl className="u-width-100px">
        <InputLabel style={{ fontSize: 'small' }}>Add Status</InputLabel>
        <Select onChange={onAdd} value="">
          {unselectedStatuses.map((option) => (
            <MenuItem key={option} value={option}>
              {statusDisplay(option)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <StatusChangeChips
        keyPrefix={emailOrUsername}
        selectedStatuses={selectedStatuses}
        onRemove={onRemove}
      />
    </>
  );
};
